export default "__VITE_ASSET__tY52pLZZ__"